import { font, colors, spacing } from '@chegg-ui/theme';
import { IconButton } from '@chegg-ui/button';
import { Tooltip } from '@chegg-ui/tooltip';
import styled, { css } from 'styled-components';

var getTypographyMixin = function getTypographyMixin(_ref) {
  var weight = _ref.weight,
      lineHeight = _ref.lineHeight,
      letterSpacing = _ref.letterSpacing;
  return css(["", " ", " ", ""], weight && "font-weight: ".concat(weight, ";"), lineHeight && "line-height: ".concat(lineHeight, ";"), letterSpacing && "letter-spacing: ".concat(letterSpacing, ";"));
};

export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        defaultBackgroundColor: colors.white,
        defaultBorderColor: colors.grey500,
        defaultTextColor: colors.grey700,
        interactiveDefaultBackgroundColor: colors.white,
        interactiveDefaultBorderColor: colors.grey500,
        interactiveDefaultTextColor: colors.grey700,
        hoverBackgroundColor: colors.grey100,
        hoverBorderColor: colors.grey900,
        hoverTextColor: colors.grey900,
        activeBackgroundColor: colors.violet800,
        activeBorderColor: colors.violet800,
        activeTextColor: colors.white,
        removeIconSpace: spacing.px40,
        removeIconRightPosition: spacing.px16,
        removeButtonPadding: "".concat(2 / 16, "rem"),
        removeButtonDefaultBackgroundColor: colors.white,
        removeButtonDefaultTextColor: colors.grey700,
        removeButtonHoverBackgroundColor: colors.grey100,
        removeButtonHoverTextColor: colors.grey700,
        removeButtonActiveBackgroundColor: colors.violet800,
        removeButtonActiveTextColor: colors.white,
        contentTypography: {
          weight: theme.font.weight.medium,
          lineHeight: theme.font.lineHeight.sm,
          letterSpacing: theme.font.letterSpacing.md
        },
        lg: {
          fontSize: font.size.px16,
          padding: "".concat(6 / 16, "rem 1rem ").concat(5 / 16, "rem"),
          removeButtonSize: 'xsmall'
        },
        md: {
          fontSize: font.size.px14,
          padding: "".concat(7 / 16, "rem 1rem ").concat(7 / 16, "rem"),
          removeButtonSize: 'xsmall'
        },
        sm: {
          fontSize: font.size.px12,
          padding: "".concat(5 / 16, "rem 1rem ").concat(3 / 16, "rem"),
          removeButtonSize: 'xsmall'
        }
      };
    },
    fanta: {
      defaultBackgroundColor: colors.greyLight,
      defaultBorderColor: colors.greyLight,
      defaultTextColor: colors.dark,
      interactiveDefaultBackgroundColor: colors.skyLight,
      interactiveDefaultBorderColor: colors.skyLight,
      interactiveDefaultTextColor: colors.dark,
      hoverBackgroundColor: colors.skyMedium,
      hoverBorderColor: colors.skyMedium,
      hoverTextColor: colors.dark,
      activeBackgroundColor: colors.skyMedium,
      activeBorderColor: colors.skyMedium,
      activeTextColor: colors.dark,
      removeIconSpace: "".concat(36 / 16, "rem"),
      removeIconRightPosition: 0,
      removeButtonPadding: 0,
      removeButtonDefaultBackgroundColor: colors.dark,
      removeButtonDefaultTextColor: colors.skyLight,
      removeButtonHoverBackgroundColor: colors.white,
      removeButtonHoverTextColor: colors.sky,
      removeButtonActiveBackgroundColor: colors.white,
      removeButtonActiveTextColor: colors.sky,
      contentTypography: {
        weight: font.weight.bold,
        lineHeight: font.lineHeight.md,
        letterSpacing: 'normal'
      },
      lg: {
        fontSize: font.size.px16,
        padding: "0 ".concat(12 / 16, "rem"),
        removeButtonSize: 'small'
      }
    },
    prop: themeProp
  };
};
export var TagRoot = styled.div.withConfig({
  componentId: "sc-1brevfd-0"
})(["position:relative;width:fit-content;width:-moz-fit-content;display:flex;"]);
export var TagContainer = styled.div.withConfig({
  componentId: "sc-1brevfd-1"
})(["width:fit-content;width:-moz-fit-content;display:flex;align-items:center;border-radius:1.5rem;font-family:", ";border:0;", " ", " ", " ", " ", ""], font.family["default"], function (_ref2) {
  var customTheme = _ref2.customTheme;
  return getTypographyMixin(customTheme.contentTypography);
}, function (_ref3) {
  var size = _ref3.size,
      customTheme = _ref3.customTheme,
      isRemovable = _ref3.isRemovable;
  return "\n    font-size: ".concat(customTheme[size].fontSize, ";\n    padding: ").concat(customTheme[size].padding, ";\n    ").concat(isRemovable ? "padding-right: ".concat(customTheme.removeIconSpace, ";") : '', "\n  ");
}, function (_ref4) {
  var onClick = _ref4.onClick,
      isRemovable = _ref4.isRemovable,
      customTheme = _ref4.customTheme,
      tagColor = _ref4.tagColor;
  return onClick || isRemovable ? "\n    background-color: ".concat(customTheme.interactiveDefaultBackgroundColor, ";\n    box-shadow: inset 0 0 0 1px ").concat(customTheme.interactiveDefaultBorderColor, ";\n    color: ").concat(customTheme.interactiveDefaultTextColor, ";\n  ") : "\n    background-color: ".concat(tagColor || customTheme.defaultBackgroundColor, ";\n    box-shadow: inset 0 0 0 1px ").concat(tagColor || customTheme.defaultBorderColor, ";\n    color: ").concat(customTheme.defaultTextColor, ";\n  ");
}, function (_ref5) {
  var onClick = _ref5.onClick,
      customTheme = _ref5.customTheme;
  return onClick ? "\n    margin: 0;\n    cursor: pointer;\n    &:hover,\n    &:focus {\n      background-color: ".concat(customTheme.hoverBackgroundColor, ";\n      box-shadow: inset 0 0 0 1px ").concat(customTheme.hoverBorderColor, ";\n      color: ").concat(customTheme.hoverTextColor, ";\n    }\n  ") : '';
}, function (_ref6) {
  var active = _ref6.active,
      customTheme = _ref6.customTheme,
      passive = _ref6.passive;
  return passive ? '' : active ? "\n            &,\n            &:hover,\n            &:focus {\n              background-color: ".concat(customTheme.activeBackgroundColor, ";\n              box-shadow: inset 0 0 1px ").concat(customTheme.activeBorderColor, ";\n              color: ").concat(customTheme.activeTextColor, ";\n            }\n          ") : '';
});
export var RemoveButton = styled(IconButton).withConfig({
  componentId: "sc-1brevfd-2"
})(["position:absolute;top:50%;border-radius:50%;padding:0;&:not(:hover){transform:translateY(-50%);}&:hover,&:focus{transform:translateY(-50%);}", ""], function (_ref7) {
  var customTheme = _ref7.customTheme,
      size = _ref7.size,
      active = _ref7.active,
      passive = _ref7.passive;
  return "\n    right: ".concat(customTheme.removeIconRightPosition, ";\n    color: ").concat(customTheme.removeButtonDefaultTextColor, ";\n    &:before {\n      content: '';\n      width: ").concat(size === 'xsmall' ? "".concat(10 / 16, "rem") : '1rem', ";\n      height: ").concat(size === 'xsmall' ? "".concat(10 / 16, "rem") : '1rem', ";\n      display: block;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      background-color: ").concat(customTheme.removeButtonDefaultBackgroundColor, ";\n      z-index: -1;\n      border-radius: 100%;\n    }\n    & > svg {\n      padding: ").concat(customTheme.removeButtonPadding, ";\n    }\n    &:hover,\n    &:focus {\n      color: ").concat(customTheme.removeButtonHoverTextColor, ";\n      &:before {\n        background-color: ").concat(customTheme.removeButtonHoverBackgroundColor, ";\n      }\n    }\n    ").concat(passive ? '' : active ? "\n      &, &:hover, &:focus {\n        color: ".concat(customTheme.removeButtonActiveTextColor, ";\n        &:before {\n          background-color: ").concat(customTheme.removeButtonActiveBackgroundColor, ";\n        }\n      }\n    ") : '', "\n  ");
});
export var LeftAlignedTooltip = styled(Tooltip).withConfig({
  componentId: "sc-1brevfd-3"
})(["& > div:last-child{left:0;}"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/tag/dist/esm/styles.js
// module id = 4059
// module chunks = 11